module.exports = __webpack_public_path__ + "img/Edda_Tor_strir_med_jotnene.95d8b429.jpg";